import React from "react";
import { __ } from "@wordpress/i18n";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from 'react';
import { useMenu } from '../../contexts/MenuContext';
import "./MegaMenu.css";

const MegaMenu = () => {
  const { menuData, communityItems } = useMenu();
  const location = useLocation();
  const currentPath = location.pathname;
  
  // State to track which menus are expanded
  const [expandedMenus, setExpandedMenus] = useState({});
  
  // Function to toggle menu expansion
  const toggleMenu = (url) => {
    setExpandedMenus(prev => ({
      ...prev,
      [url]: !prev[url]
    }));
  };

  // Check if a path is active
  const isActive = (url) => {
    if (url === '/settings' && currentPath === '/settings') {
      return true;
    }
    return currentPath.startsWith(url) && url !== '/settings';
  };

  // Initialize expanded state based on active path
  useEffect(() => {
    const newExpandedState = {};
    
    const checkActiveSubmenu = (items) => {
      items.forEach(item => {
        if (item.sub && item.sub.length > 0) {
          // Check main submenu
          const isSubmenuActive = item.sub.some(subItem => 
            currentPath.startsWith(subItem.url)
          );
          
          // Also check nested submenus
          let hasActiveNestedSubmenu = false;
          item.sub.forEach(subItem => {
            if (subItem.sub && subItem.sub.length > 0) {
              const isNestedActive = subItem.sub.some(nestedItem => 
                currentPath.startsWith(nestedItem.url)
              );
              if (isNestedActive) {
                newExpandedState[subItem.url] = true;
                hasActiveNestedSubmenu = true;
              }
            }
          });
          
          if (isSubmenuActive || hasActiveNestedSubmenu) {
            newExpandedState[item.url] = true;
          }
        }
      });
    };
    
    checkActiveSubmenu(menuData);
    checkActiveSubmenu(communityItems);
    
    setExpandedMenus(newExpandedState);
  }, [currentPath]);

  // Helper function to render menu items
  const renderMenuItems = (items) => {
    return items.map((item, index) => (
      <li
        key={index}
        className={`menu-item ${item.sub?.length > 0 ? 'menu-item-has-children' : ''} ${
          isActive(item.url) ? 'menu-item-active-link' : ''
        }`}
      >
        {item.sub?.length > 0 ? (
          // Menu items with submenus get a div with click handler
          <div 
            className={`menu-link ${isActive(item.url) ? 'active' : ''}`}
            onClick={() => toggleMenu(item.url)}
          >
            {item.icon && <img src={item.icon} alt="icon" className="menu-icon" />}
            <span className="menu-text">{item.title}</span>
            <span className="dropdown-icon">
              {expandedMenus[item.url] ? <img src={ultimate_security_ajax_obj.imageUrl+"ArrowUp.svg"} alt="plugin-icon"/> : <img src={ultimate_security_ajax_obj.imageUrl+"ArrowDown.svg"} alt="plugin-icon"/>}
            </span>
          </div>
        ) : (
          // Menu items without submenus get a Link component
          item.url.startsWith("http") ? (
            <a 
              href={item.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={`menu-link ${isActive(item.url) ? 'active' : ''}`}
            >
              {item.icon && <img src={item.icon} alt="icon" className="menu-icon" />}
              <span className="menu-text">{item.title}</span>
            </a>
          ) : (
            <Link 
              to={item.url} 
              className={`menu-link ${isActive(item.url) ? 'active' : ''}`}
            >
              {item.icon && <img src={item.icon} alt="icon" className="menu-icon" />}
              <span className="menu-text">{item.title}</span>
            </Link>
          )
          
        )}

        {item.sub?.length > 0 && expandedMenus[item.url] && (
          <div className="submenu">
            <ul>
              {item.sub.map((subItem, subIndex) => (
                <li
                  key={subIndex}
                  className={`${currentPath === subItem.url ? 'menu-item-active-link' : ''} ${
                    subItem.sub?.length > 0 ? 'has-nested-submenu' : ''
                  }`}
                >
                  {subItem.sub?.length > 0 ? (
                    <>
                      <div 
                        className={`menu-link nested-menu-title ${isActive(subItem.url) ? 'active' : ''}`}
                        onClick={() => toggleMenu(subItem.url)}
                      >
                        <span className="menu-text">{subItem.title}</span>
                        <span className="dropdown-icon">
                          {expandedMenus[subItem.url] ? <img src={ultimate_security_ajax_obj.imageUrl+"ArrowUp.svg"} alt="plugin-icon"/> : <img src={ultimate_security_ajax_obj.imageUrl+"ArrowDown.svg"} alt="plugin-icon"/>}
                        </span>
                      </div>
                      
                      {expandedMenus[subItem.url] && (
                        <div className="nested-submenu">
                          <ul>
                            {subItem.sub.map((nestedItem, nestedIndex) => (
                              <li
                                key={nestedIndex}
                                className={`${currentPath === nestedItem.url ? 'menu-item-active-link' : ''}`}
                              >
                                <Link to={nestedItem.url} className="menu-link">
                                  <span className="menu-text">{nestedItem.title}</span>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </>
                  ) : (
                    <Link to={subItem.url} className={`menu-link ${currentPath === subItem.url ? 'active' : ''}`}>
                      <span className="menu-text">{subItem.title}</span>
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </li>
    ));
  };

  return (
    <div className="megamenu-wrapper">
      <h3 className="settings-title pl-heading-1 fw-700">{__("Settings","ultimate-security")}</h3>
      <nav>
        <ul className="side-menu">
          {renderMenuItems(menuData)}
        </ul>
      </nav>
      
      <h3 className="support-title pl-heading-1 fw-700">{__("Community & Support","ultimate-security")}</h3>
      <nav>
        <ul className="side-menu">
          {renderMenuItems(communityItems)}
        </ul>
      </nav>
      <div className="pl-brand" style={{backgroundImage:`url(${ultimate_security_ajax_obj.imageUrl+"pl-bg.png"})`}}>
        <div className="heading-text">
          <h4 className="pl-heading fw-600">{__("Learn more","ultimate-security")}<br></br> {__("about us","ultimate-security")}</h4>
        </div>
        <a href="https://wpultimatesecurity.com/" className="button button-primary" style={{borderRadius:"8px",fontSize:"16px"}} target="_blank">{__("Learn More","ultimate-security")}</a>
      </div>
    </div>
  );
};

export default MegaMenu;